import { useInfiniteQuery } from '@tanstack/react-query';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { ResponseDataWithPagination } from '@/types/apiTypes';
import type { AuditLogItemType } from '../../components/tabs/LogsInformation';

const PER_PAGE = 4;

export const AUDIT_LOGS_QUERY_KEY = 'audit-logs';

export const useGetClientAuditLogsQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const [searchQuery] = useSearchQuery();
  const clientId = searchQuery.get(CLIENT_ID_QUERY_KEY);

  const { doFetch } = useFetch<void, ResponseDataWithPagination<AuditLogItemType[]>>();

  return useInfiniteQuery({
    queryKey: [AUDIT_LOGS_QUERY_KEY, clientId],
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) =>
      doFetch(`/api/audit-logs/client/${clientId}?per_page=${PER_PAGE}&page=${pageParam}`),
    getNextPageParam: (lastPage) => {
      const p = lastPage.pagination;
      if (!p) return undefined;
      return p.current_page < p.last_page ? p.current_page + 1 : undefined;
    },
    enabled: !!clientId && enabled,
  });
};
